import React from 'react';
import type { FC } from 'react';
import { Text } from '@wix/cli-ui-kit';
import type { LogMessage, LogMessageLevel } from './logsReqHandler.js';

export const ServerLogMessage: FC<{
  message: LogMessage;
  level: LogMessageLevel;
}> = ({ message, level }) => {
  let content = 'unknown';

  if (typeof message === 'object') {
    content = JSON.stringify(message);
  } else {
    content = String(message);
  }

  return <Text skin={level === 'error' ? 'error' : 'standard'}>{content}</Text>;
};
